import { useCallback } from 'react'
import { router } from '@inertiajs/react'
import { useModalSheetContext, type ModalReloadOptions } from '@components/ModalSheet'

export function useModalReload() {
  const modalContext = useModalSheetContext()

  return useCallback(
    (options?: ModalReloadOptions) => {
      if (modalContext) {
        modalContext.reload(options)
      } else {
        router.reload(options)
      }
    },
    [modalContext]
  )
}
